import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";

export const about = type => {
  //<h2 id="contentsHead">
  //	<img src="resource/img/static/about/index.gif" width="870" height="41" alt="セルフストレージとは"/>
  //</h2>
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜セルフストレージとは';

  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "セルフストレージとは" }])}
      
      <div className="about">
        <h2 id="contentsHead">セルフストレージとは</h2>
        <div className="box02">
          <h3>米国のセルフストレージ（貸し倉庫・レンタル倉庫）に関する現状</h3>
          <div className="box02Txt">
            <p className="b02Img">
              <img
                src="resource/img/static/about/img01.jpg"
                width="200"
                height="150"
                alt="米国のセルフストレージ（貸し倉庫・レンタル倉庫）に関する現状"
              />
            </p>
            <p>
              米国では、セルフストレージ（貸し倉庫・レンタル倉庫）の店舗は全米に
              45,000
              箇所以上あり、2005年度の調査によると全米の世帯の9%（11世帯に1件の割合）に達し、まさに日常生活の一部として各家庭に浸透しつつあります。
            </p>
            <p>
              この業界は
              1995年から2005年にかけて、年間の総売上額も実に75%も増加しました。自宅のガレージにやっと自分の車を入れることが出来た、親から譲り受けた家具・自分の趣味趣向に合わせて購入して来た家財道具をセルフストレージに収め、今の自分のライフスタイルに合わせたインテリア空間を作ることができる・・・これが精神衛生上にもプラスなため、トレンドを広げていると考えられています。
            </p>
            <p>（At Slate.com社のTom Vanderbilt氏の著書による）</p>
          </div>
        </div>
        <div className="box02">
          <h3>エリアリンク株式会社から「収納ご提案」</h3>
          <div className="box02Txt">
            <p className="b02Img">
              <img
                src="resource/img/static/about/img02.jpg"
                width="200"
                height="300"
                alt="エリアリンク株式会社から「収納ご提案」"
              />
            </p>
            <p>
              実際に屋内型トランクルームの場合、一番小さな床面積1.5帖のスペースなら月7,000円以下から。
              <br />
              このお値段、安いでしょうか？それとも高いでしょうか？
            </p>
            <p>
              例えば女性のひとり暮らしかカップルの2人暮らしを考えたとき、都心だと40～50平方メートルで賃料は15万円くらいします。屋内型トランクルームの場合、床面積の3倍は収納できますから、4.5帖分（約7.4平方メートル）部屋を広く使えるんです。自分の部屋をよく見渡してください。もしも4.5帖分の荷物や家具がなくなったと考えると、家賃に比べて割安だと思いませんか？
            </p>
            <p>
              モノがあふれた暮らしに疲れてしまった人、流行のシンプルライフを送りたいけどうまく収納できないという女性にとっても、これは朗報かもしれません。
            </p>
            <p>
              東京都杉並区の早稲田通り沿いのハローストレージを訪れ、利用している人に話を聞いてみると、
            </p>
            <ul className="b02Voice">
              <li>
                「いままで玄関周りにおいてあったゴルフや靴などを収納したら、玄関が広くなりました」(50代女性)
              </li>
              <li>
                「スノーボードやキャンプ用品など、その季節しか使わないものを入れています」(30代男性)
              </li>
            </ul>
            <p>
              などの回答をいただきました。利用者の満足度は高いようです。
              <br />
              そのほかには、ひな人形のセット、タイヤ、本、コレクターグッズなど、めったに使わないけどかさばって高価なものを収納するのに、利用している人が多いようです。
            </p>
            <p>
              それにしても、『捨てる！技術』という本がベストセラーになったことがありましたが、これだけ皆様が収納に困るということは、よっぽど日本の住宅が狭いのか、それとも物が捨てられない国民性なのでしょうか？
              <br />
              私達は国民性ではないと考えています。前述のように国土の広いアメリカのほうが、収納産業は日本より盛んですし、ただ、日本のほうが引越しコストが高く、1箇所に定住する傾向はあります。同じところに長く住んでいれば、次第に物が増えてくるのは当たり前といえるでしょう。
            </p>
            <p>
              住宅の広さは変わらない一方で、今はまさに都心回帰がトレンドです。同じ予算や広さで、より都心にという心理もあるようです。
              どうせ限られた住宅スペース、より広く使うため、もしくは家賃の節約、心の健康のためにも、レンタル収納スペースサービス、あなたも検討の余地があるのではないでしょうか？
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/static/about.jsx